// extracted by mini-css-extract-plugin
export default {"caption":"styles__caption___-hHae"};